<template>
  <div>
    <div :class="embutido ? '' : 'card'">
      <div :class="embutido ? '' : 'card-header'">
        <div v-if="!embutido" class="card-title">
          <h5 class="card-label">Contatos</h5>
        </div>

        <hr v-if="!embutido" />
        <div :class="embutido ? '' : 'mt-5'">
          <b-row>
            <!-- Contas: some quando a tela é aberta pela Central de Contas.
            Lá a conta já vem fixa da linha clicada e aparece no cabeçalho do
            modal, então deixar o seletor editável faria o título mentir sobre
            o que está na tabela. -->
            <b-col v-if="!embutido" cols="12" md="3" class="mb-3 mb-md-0">
              <div class="d-flex flex-column">
                <MultiSelect
                  v-model="contasSelecionadas"
                  :options="contas"
                  optionValue="id"
                  optionLabel="label"
                  placeholder="Selecione a conta"
                  :filter="true"
                  class="w-100"
                  :class="{
                    'p-invalid': !contasSelecionadas.length && contasInvalidas
                  }"
                  appendTo="body"
                >
                  <template #option="slotProps">
                    <div class="conta-option" v-blur-sensitive>
                      {{ slotProps.option.id }} -
                      {{ slotProps.option.login }}
                      <span v-if="slotProps.option.nome">
                        ({{ slotProps.option.nome }})
                      </span>
                    </div>
                  </template>
                </MultiSelect>

                <small
                  class="p-invalid"
                  v-if="!contasSelecionadas.length && contasInvalidas"
                >
                  Selecione uma conta, caso não tenha nenhum telefone
                </small>
              </div>
            </b-col>

            <!-- Telefone -->
            <b-col cols="12" md="3" class="mb-3 mb-md-0">
              <InputText
                id="telefone"
                type="text"
                v-model="telefone"
                @keyup.enter="fetchData"
                placeholder="Informe o número exato de telefone"
                class="w-100"
                :class="{ 'p-invalid': !telefone && telefoneInvalido }"
                v-blur-sensitive
              />
            </b-col>

            <!-- Status -->
            <b-col cols="12" md="2" class="mb-3 mb-md-0">
              <Dropdown
                v-model="status"
                :options="optionsStatus"
                optionLabel="name"
                optionValue="value"
                placeholder="Status"
                :showClear="true"
                class="w-100"
              />
            </b-col>

            <!-- Callback -->
            <b-col cols="12" md="2" class="mb-3 mb-md-0">
              <Dropdown
                v-model="hasCallback"
                :options="optionsCallback"
                optionLabel="name"
                optionValue="value"
                placeholder="Callback"
                :showClear="true"
                class="w-100"
              />
            </b-col>

            <!-- Botão -->
            <b-col cols="12" md="2" class="mb-3 mb-md-0">
              <Button
                label="Filtrar"
                @click="fetchData"
                :disabled="isLoading"
                class="w-100"
                style="color: white"
              />
            </b-col>
          </b-row>
        </div>
        <b-table
          striped
          hover
          :items="items"
          :fields="fields"
          :busy="isLoading"
          responsive="sm"
          empty-text="Nenhum registro encontrado"
          @sort-changed="sortChanged"
        >
          <template #cell(conta_id)="row">
            <span v-blur-sensitive>
              {{ contas.find((c) => c.id === row.value).login }} ({{
                row.value
              }})
            </span>
          </template>

          <template #cell(cco_telefone)="row">
            <span v-blur-sensitive>{{ row.value }}</span>
          </template>

          <template #cell(msg_data_cadastro)="row">
            {{ formatarData(row.value) }}
          </template>

          <template #cell(cco_status)="row">
            <div class="d-flex align-items-center">
              <div
                v-if="row.value == 'S'"
                style="
                  background-color: #c9f7f5;
                  width: 30px;
                  border-radius: 5px;
                "
                class="d-flex justify-content-center align-items-center p-2 mr-1"
                v-b-tooltip.noninteractive
                title="Desbloqueado"
              >
                <i style="color: #1bc5bd" class="fas fa-lock-open"></i>
              </div>
              <div
                v-else
                style="
                  background-color: #ffe2e5;
                  width: 30px;
                  border-radius: 5px;
                "
                class="d-flex justify-content-center align-items-center p-2 mr-1"
                v-b-tooltip.noninteractive
                title="Bloqueado"
              >
                <i style="color: #f64e60" class="fas fa-lock"></i>
              </div>
              <div
                :id="`icone-callback-${row.item.mensagem_id}`"
                v-if="row.item.callback"
                style="
                  background-color: #bbe3f9;
                  width: 30px;
                  height: 30px;
                  border-radius: 5px;
                "
                class="d-flex justify-content-center align-items-center p-2 pt-3 mr-1"
              >
                <i style="color: #4e97f6" class="flaticon2-reply"></i>
              </div>
              <b-tooltip :target="`icone-callback-${row.item.mensagem_id}`">
                <div>
                  <div class="d-flex">
                    <i class="fa fa-comment-alt mr-3"></i>
                    <p
                      style="
                        text-align: left;
                        font-size: 0.8rem;
                        word-wrap: break-word;
                        word-break: break-word;
                        white-space: normal;
                        max-width: 300px;
                        overflow-wrap: break-word;
                      "
                    >
                      <span v-blur-sensitive>{{ row.item.msg_conteudo }}</span>
                    </p>
                  </div>
                  <div class="d-flex">
                    <i class="flaticon2-reply mr-3"></i>
                    <p
                      style="
                        text-align: left;
                        font-size: 0.8rem;
                        word-wrap: break-word;
                        word-break: break-word;
                        white-space: normal;
                        max-width: 300px;
                        overflow-wrap: break-word;
                      "
                    >
                      <span v-blur-sensitive>{{ row.item.callback }}</span>
                    </p>
                  </div>
                </div>
              </b-tooltip>
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner small type="grow"></b-spinner>
              <span class="ml-2">Carregando...</span>
            </div>
          </template>

          <template #empty>
            <div class="text-center my-2">
              <b-icon icon="exclamation-circle" variant="danger" size="2rem" />
              <p>Nenhum registro encontrado</p>
            </div>
          </template>

          <template #cell(actions)="row">
            <b-dropdown
              no-caret
              variant="outline-secondary"
              id="dropdown-dropleft"
              dropleft
              class="border-0"
            >
              <template #button-content>
                <b-icon-three-dots-vertical />
              </template>
              <b-dropdown-item
                v-if="row.item.cco_status == 'N'"
                @click="ativarConta(row.item)"
                href="#"
                >Desbloquear</b-dropdown-item
              >
              <b-dropdown-item v-else @click="bloquearConta(row.item)" href="#"
                >Bloquear</b-dropdown-item
              >
              <b-dropdown-item
                @click="limparCallback(row.item)"
                v-if="row.item.callback"
                href="#"
                >Limpar callback</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>

        <div v-if="!items.length">
          <b-alert show variant="info"> Nenhum registro encontrado </b-alert>
        </div>

        <div class="row" v-if="totalRows > 0">
          <div class="col-md-4">
            <b-form-group>
              <b-form-select
                :options="optionsPerPage"
                v-model="perPage"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-pagination
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="perPage"
              align="fill"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "primevue/multiselect";
import InputText from "primevue/inputtext";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import moment from "moment-timezone";

export default {
  name: "Contatos",
  components: { MultiSelect, InputText, Dropdown, Button },
  props: {
    // WEL-5504: preenchido quando a tela é aberta pela Central de Contas
    // (ModalContatos), fixando os contatos na conta da linha clicada. Nulo =
    // tela cheia do menu lateral, onde o super-admin escolhe as contas.
    contaFixaId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      items: [],
      totalRows: 0,
      optionsPerPage: [
        {
          value: 10,
          text: "Exibir 10 registros por página"
        },
        {
          value: 20,
          text: "Exibir 20 registros por página"
        },
        {
          value: 50,
          text: "Exibir 50 registros por página"
        },
        {
          value: 100,
          text: "Exibir 100 registros por página"
        }
      ],
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDirection: "",
      status: null,
      optionsStatus: [
        { name: "Desbloqueado", value: "S" },
        { name: "Bloqueado", value: "N" }
      ],
      telefone: "",
      hasCallback: null,
      optionsCallback: [
        { name: "Com callback", value: true },
        { name: "Sem callback", value: false }
      ],
      isLoading: false,
      contas: [],
      contasSelecionadas: [],
      telefoneInvalido: false,
      contasInvalidas: false
    };
  },
  computed: {
    ...mapGetters(["contasParaTroca"]),

    embutido() {
      return this.contaFixaId !== null && this.contaFixaId !== "";
    },

    // A coluna "Conta" só faz sentido quando a busca pode misturar contas.
    // Com a conta fixa ela repetiria o cabeçalho do modal em toda linha.
    fields() {
      const colunas = [
        { key: "cco_telefone", label: "Telefone" },
        {
          key: "msg_data_cadastro",
          label: "Data da última mensagem",
          sortable: true
        },
        { key: "cco_status", label: "Status", sortable: true },
        { key: "actions", label: "Ação" }
      ];

      if (this.embutido) {
        return colunas;
      }

      return [{ key: "conta_id", label: "Conta" }, ...colunas];
    }
  },
  methods: {
    async fetchData(ctx) {
      if (!this.contasSelecionadas.length && !this.telefone) {
        this.contasInvalidas = true;
        return;
      }
      if (!this.telefone && !this.contasSelecionadas.length) {
        this.telefoneInvalido = true;
        return;
      }
      this.telefoneInvalido = this.contasInvalidas = false;

      this.isLoading = true;
      try {
        const response = await ApiService.get("/conta-contato", null, true, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            telefone: this.telefone,
            cco_status: this.status,
            conta_id: this.contasSelecionadas,
            sort_by: this.sortBy,
            sort_direction: this.sortDirection,
            has_callback: this.hasCallback
          }
        });

        this.items = response.data.data;
        this.totalRows = response.data.total_records;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async bloquearConta(conta) {
      try {
        Swal.fire({
          title: "Você tem certeza?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ffa800",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, bloquear contato!",
          cancelButtonText: "Cancelar"
        }).then(async (result) => {
          if (result.isConfirmed) {
            await ApiService.post(
              `/conta-contato/${conta.conta_id}/${conta.cco_telefone}/status`,
              { status: "N" }
            );
            this.fetchData();
          }
        });
      } catch (error) {
        console.error("Erro ao ativar conta:", error);
      }
    },
    async ativarConta(conta) {
      try {
        Swal.fire({
          title: "Você tem certeza?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ffa800",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, desbloquear contato!",
          cancelButtonText: "Cancelar"
        }).then(async (result) => {
          if (result.isConfirmed) {
            await ApiService.post(
              `/conta-contato/${conta.conta_id}/${conta.cco_telefone}/status`,
              { status: "S" }
            );
            this.fetchData();
          }
        });
      } catch (error) {
        console.error("Erro ao ativar conta:", error);
      }
    },
    async limparCallback(conta) {
      try {
        Swal.fire({
          title: "Você tem certeza?",
          text: "Você não poderá reverter esta ação!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ffa800",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, limpar callback!",
          cancelButtonText: "Cancelar"
        }).then(async (result) => {
          if (result.isConfirmed) {
            await ApiService.post(
              `/conta-contato/${conta.mensagem_id}/limpar-callback`
            );
            this.fetchData();
          }
        });
      } catch (error) {
        console.error("Erro ao limpar callback:", error);
      }
    },
    sortChanged(e) {
      this.sortBy = e.sortBy;
      this.sortDirection = e.sortDesc ? "desc" : "asc";
      this.fetchData();
    },
    formatarData(data) {
      if (!data) {
        return "";
      }
      let dataMoment = moment(data);
      return dataMoment.isValid() ? dataMoment.format("DD/MM/YYYY HH:mm") : "";
    }
  },
  mounted() {
    this.contas = this.contasParaTroca.map((conta) => ({
      ...conta,
      label: `${conta.id} - ${conta.login} ${
        conta.nome ? "(" + conta.nome + ")" : ""
      }`
    }));

    // Dentro do modal não há breadcrumb pra alimentar, e como a conta já veio
    // escolhida a lista é carregada de imediato: o usuário clicou em
    // "Contatos" daquela conta, não faz sentido pedir um "Filtrar" a mais.
    if (this.embutido) {
      this.contasSelecionadas = [Number(this.contaFixaId)];
      this.fetchData();
      return;
    }

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Contatos" }]);
  },
  watch: {
    currentPage: "fetchData",
    perPage: "fetchData"
  }
};
</script>

<style lang="scss" scoped></style>
<style>
/* Limita largura do painel */
.p-multiselect-panel {
  max-width: 420px;
}

/* Permite quebra dentro da option */
.conta-option {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
}

/* Muito importante: permite quebrar dentro do item */
.p-multiselect-item {
  white-space: normal !important;
  align-items: flex-start !important;
}
</style>
